import logo from './logo.svg';
import './App.css';
import Navbar from './Component/Navbar';
import Project from './Pages/Project';
//
function App() {
  return (
    <div className="App">
    
    <Navbar/>
    {/*  het */}
    </div>
  );
}

export default App;